import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Typography as material_Typography } from "@mui/material";
const Typography_Typography = /*#__PURE__*/ forwardRef(function(props, ref) {
    if (void 0 === props.component) {
        if (void 0 === props.variant) return /*#__PURE__*/ jsx(material_Typography, {
            component: "div",
            ref: ref,
            ...props
        });
        if (props.variant?.startsWith('body')) return /*#__PURE__*/ jsx(material_Typography, {
            component: "div",
            ref: ref,
            ...props
        });
        if (props.variant && [
            'caption',
            'code',
            'button',
            'overline1',
            'overline2'
        ].includes(props.variant)) return /*#__PURE__*/ jsx(material_Typography, {
            component: "span",
            ref: ref,
            ...props
        });
    }
    return /*#__PURE__*/ jsx(material_Typography, {
        ref: ref,
        ...props
    });
});
export { Typography_Typography as Typography };

//# sourceMappingURL=Typography.js.map